<template>
  <div
    :class="{ odd: isOdd }"
    :data-virtual-list-index="index"
    :style="{
      minHeight:
        typeof source.subtracks !== 'undefined' && expandedOverride
          ? (source.subtracks.length + 1) * trackListRowDefaultSize + 'px'
          : trackListRowDefaultSize + 'px',
    }"
    class="card card-track-row card-track-parent-row"
  >
    <div class="card-header track-draggable-handle">
      <track-list-row
        v-bind:expanded="expandedOverride"
        v-bind:is-parent-track="true"
        v-bind:parentUid="_uid"
        v-bind:projectId="projectId"
        v-bind:track="source"
        v-on:toggle-expanded="onToggleExpanded"
        v-bind:asseturl="asseturl"
      ></track-list-row>
    </div>

    <div
      :class="{
        'collapse-expanded': expandedOverride,
        collapsed: !expandedOverride,
      }"
      :data-trackid="source.id"
      :style="{
        maxHeight: source.subtracks.length * trackListRowDefaultSize + 'px',
      }"
      class="collapse-subtrack"
      role="tabpanel"
      v-bind:id="'collapseTrackListRowUid' + _uid + '' + source.id"
      v-if="source && source.subtracks && source.subtracks.length"
    >
      <div class="card-body">
        <div
          class="card card-track-row card-subtrack-row"
          v-bind:index="subtrackIndex"
          v-bind:key="subtrackIndex"
          v-for="(subtrack, subtrackIndex) in source.subtracks"
        >
          <div class="card-header track-draggable-handle" role="tab">
            <track-list-row
              v-bind:is-parent-track="false"
              v-bind:parentUid="_uid"
              v-bind:projectId="projectId"
              v-bind:track="subtrack"
              v-if="expandedOverride"
              v-bind:asseturl="asseturl"
            ></track-list-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.component("track-list-row-wrapper", {
  data: function () {
    return {
      expandedOverride: false,
      inView: false,
    };
  },

  props: {
    asseturl: {
      type: String,
      required: true,
    },

    parentUid: {
      type: String | Number,
      required: true,
    },

    projectId: {
      required: false,
      default: false,
    },

    trackListRowDefaultSize: {
      type: Number,
    },

    expanded: {
      type: Boolean,
    },

    index: {
      // index of current item in the tracklist
      type: Number,
    },

    source: {
      // This is the data contained from the track passed from the API
      type: Object,
      default() {
        return {};
      },
    },

    isVirtualList: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  created() {
    // Set from the tracklist expanded cache
    if (
      typeof window.tracklistExpandedCache != "undefined" &&
      typeof window.tracklistExpandedCache[this.parentUid] != "undefined" &&
      typeof window.tracklistExpandedCache[this.parentUid][this.source.id] !=
        "undefined"
    ) {
      this.expandedOverride =
        window.tracklistExpandedCache[this.parentUid][this.source.id];
    } else {
      this.expandedOverride = this.expanded;
    }
  },

  computed: {
    isOdd() {
      return this.isVirtualList && this.index % 2;
    },
  },

  mounted() {},

  methods: {
    onToggleExpanded() {
      this.expandedOverride = !this.expandedOverride;
    },

    updateExpandedCache(newValue) {
      if (typeof window.tracklistExpandedCache == "undefined") {
        window.tracklistExpandedCache = [];
      } else if (
        typeof window.tracklistExpandedCache[this.parentUid] == "undefined"
      ) {
        window.tracklistExpandedCache[this.parentUid] = [];
      }

      window.tracklistExpandedCache[this.parentUid][this.source.id] = newValue;
    },
  },

  watch: {
    expanded(newValue, oldValue) {
      this.expandedOverride = newValue;
    },

    expandedOverride(newValue, oldValue) {
      this.updateExpandedCache(newValue);
    },
  },
});
</script>
